module.exports = __webpack_public_path__ + "static/video-bg-8765565e09c70a77012887c1e4525208.png";